import {
  AntiDilutionRights,
  CouponType,
  HoldingClassType,
  LiquidationPreferenceType,
  MonitoringRights,
} from 'further-types/lp/holding-class';

export const LiquidationPreferenceLabels = {
  [LiquidationPreferenceType.None]: 'None',
  [LiquidationPreferenceType.NonParticipating]: 'Non-Participating',
};

export const AntiDilutionLabels = {
  [AntiDilutionRights.None]: 'None',
  [AntiDilutionRights.NarrowBased]: 'Narrow-Based',
};

export const CouponTypeLabels = {
  [CouponType.None]: 'None',
  [CouponType.Cash]: 'Cash',
};

export const MonitoringRightsLabels = {
  [MonitoringRights.None]: 'None',
  [MonitoringRights.ObserverRights]: 'Observer Rights',
};

export const HoldingClassLabels = {
  [HoldingClassType.Common]: 'Common',
  [HoldingClassType.Preferred]: 'Preferred',
};
